import { useQuery } from 'react-query';

import { getTotalEatenBaitLineChart } from 'api/analitics/SBSCharts/1_TotalEatenBaitLineChart';

export const useGetTotalEatenBaitLineChart = (
  slug: string,
  period: string,
  step: string,
  startDate: string,
  endDate: string,
  enabled?: boolean,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'TotalEatentBaitLineChartData',
    () => getTotalEatenBaitLineChart(slug, period, step, startDate, endDate),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetTotalEatenBaitLineChart;
